import PerformanceDetailsModal from "./PerformanceDetailsModal";

export default PerformanceDetailsModal;